import { checkMaximoConfig } from "../../views/Installer/services";

const maximoConfig = (slices) => (store) => (next) => async (action) => {
  let result = null;

  if (action.type === "checkMaximoConfig") {
    try {
      let config = null;
      let installation = null;

      store.dispatch({
        type: "dashboard/setLoading",
        payload: {
          isLoading: true,
        },
      });
      const response = await checkMaximoConfig();
      if (!response.content || response?.status === "failure") {
        store.dispatch({
          type: "dashboard/setLoading",
          payload: {
            isLoading: false,
          },
        });
        store.dispatch({
          type: "dashboard/setGetCongfigError",
          payload: {
            getConfigError: response?.message ?? response,
          },
        });
      } else {
        config = response?.content?.availableConfig === true;

        installation = response?.content?.completedInstallation === true;

        store.dispatch({
          type: "dashboard/setLoading",
          payload: {
            isLoading: false,
          },
        });
        store.dispatch({
          type: "dashboard/updateAvailableConfig",
          payload: {
            isAvailableConfig: config,
          },
        });
        store.dispatch({
          type: "installer/updateCompletedInstallation",
          payload: {
            installationStatus: installation,
          },
        });

        store.dispatch({
          type: "dashboard/setGetCongfigError",
          payload: {
            getConfigError: null,
          },
        });
      }
    } catch (error) {
      store.dispatch({
        type: "dashboard/setLoading",
        payload: {
          isLoading: false,
        },
      });
      store.dispatch({
        type: "dashboard/setGetCongfigError",
        payload: {
          getConfigError: error?.message ?? error,
        },
      });
    }
  }
  result = next(action);

  return result;
};

export default maximoConfig;
